<template>
	<div class="qr-code">
		<div class="infobar__icon">
			<img
				class="infobar__icon"
				svg-inline
				:src="`https://chart.googleapis.com/chart?cht=qr&chl=${qr}&chs=160x160&chld=L%7C0`"
				alt="icon"
				focusable="false"
				role="presentation"
			/>
		</div>
	</div>
</template>

<script>
export default {
	name: 'QRCode',
	props: {
		qr: {
			type: String,
			default: ''
		}
	}
}
</script>

<style scoped lang="scss">
	.qr-code {
		padding: 20px;
		display: flex;
		flex-direction: row;

		&__icon {
			svg {
			fill: $colorPrimary;
			width: 25px;
			height: 25px;
			}
		}

		&__text {
			margin-left: 10px;
		}

		&__message {
			margin-bottom: 10px;
		}

		p {
			text-align: left;
			
		}

		a {
			color: inherit

		}

	}
</style>
